/**
 * Numeric height disables legend auto-grow in {@link useGraphOptions}.
 * `override` (widget fill) wins; otherwise the chart-type default (vector: 150).
 * `undefined` keeps the map-panel default (400 + legend).
 */
export function resolveGraphChartHeight(
  override?: number,
  typeDefault?: number,
): number | undefined {
  return override ?? typeDefault;
}
